/* eslint-disable @next/next/no-img-element */
import { useContext } from 'react';
import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';
import { MPosContext } from 'utils/context';
import { useRouter } from 'next/router';
import { useFetchParams } from 'hooks/useFetchParams';
import { useViewport } from 'utils/responsive';
import {
    NewPlanStages,
    policyDetailsInitState,
} from 'components/newPlan/constants';
import {
    SegmentEventNameTypes,
    SegmentEventActionTypes,
    SegmentEventButtonNames,
    PRODUCT,
    SUB_PRODUCT_NAME,
    SegmentEventActionNames,
} from 'utils/segment/constants';
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics';
import * as Styles from './styles';
import { AckoLogoConfig } from 'utils/constants';

function Header({ wrapperStyles = {} }) {
    const { lob } = useFetchParams();
    const router = useRouter();
    const {
        partnerId,
        permissions,
        showHamburger,
        setShowHamburger,
        setActiveStage,
        setPlanDetails,
    } = useContext(MPosContext);

    const isLoginPage = router.pathname.includes('login');
    const { isMobile } = useViewport();

    const getPartnerLogo = () => {
        try {
            const { partner_logo } = permissions;
            if (partner_logo) {
                return partner_logo;
            }
            switch (partnerId) {
                case 'oppo':
                    return '/logos/oppo.png';
                case 'ather':
                    return '/logos/ather.svg';
                default:
                    return '';
            }
        } catch {
            return '';
        }
    };

    const logoOnClick = () => {
        if (!isLoginPage) {
            setShowHamburger(false);
            setActiveStage(NewPlanStages.MODEL);
            setPlanDetails(policyDetailsInitState);
            if (
                permissions.permission_list.includes(
                    'access_only_auto_commercial_flow'
                )
            ) {
                router.push(`/${lob}/${partnerId}/form`);
                return;
            }
            router.push(`/${lob}/${partnerId}/dashboard`);
        }
    };

    const onClickMenu = () => {
        setShowHamburger((s: boolean) => !s);

        /**
         * segment event
         */

        trackEvent(SegmentEventNameTypes.ACTION, {
            page_url: window?.location?.href || '',
            action_type: SegmentEventActionTypes.TAP_BTN,
            button_name: SegmentEventButtonNames.MENU,
            product: PRODUCT,
            sub_product: SUB_PRODUCT_NAME,
            platform: isMobile ? 'mweb' : 'web',
            device: navigator.userAgent || '',
            partner: partnerId,
            action_name: SegmentEventActionNames.CLICK_MENU,
        });
    };

    const partnerLogo = getPartnerLogo();

    return (
        <Styles.Wrapper style={wrapperStyles}>
            <Styles.LogosWrapper>
                <Styles.AckoLogoWrapper>
                    <Image
                        src={AckoLogoConfig.gradient}
                        width={'82px'}
                        height={'26px'}
                        onClick={logoOnClick}
                    />
                </Styles.AckoLogoWrapper>
                {partnerLogo && (
                    <Styles.PartnerLogoWrapper>
                        <div
                            style={{
                                borderLeft: '1px solid #E7E7F0',
                                marginRight: '15px',
                            }}
                        ></div>
                        <div style={{ display: 'flex' }}>
                            <Image
                                src={partnerLogo}
                                width={'70px'}
                                height={'22px'}
                                alt={''}
                            />
                        </div>
                    </Styles.PartnerLogoWrapper>
                )}
            </Styles.LogosWrapper>
            {!isLoginPage && (
                <Styles.HamburgerWrapper>
                    <Image
                        style={{ cursor: 'pointer' }}
                        src={getImageBasePath(
                            showHamburger
                                ? '/icons/close.svg'
                                : '/icons/hamburger.svg'
                        )}
                        width={'24px'}
                        height={'24px'}
                        onClick={onClickMenu}
                    />
                </Styles.HamburgerWrapper>
            )}
        </Styles.Wrapper>
    );
}

export default Header;
